<template>
  <div class="main">
    <back title="烘焙甜点精英班"></back>
    <landingBanner
      landingUrl="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking6/banner.jpg"
    ></landingBanner>
    <div class="content">
      <indexTitle
        title1="免费获取课程学费"
        title2="To get the tuition"
      ></indexTitle>
      <footerForm color="#fff" bag="#a96b04" words="获取学费"></footerForm>
      <indexTitle
        title1="课程学习内容"
        title2="欧洲地道的西点烘焙技艺，让你成为西点大师"
      ></indexTitle>
      <div class="class">
        <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/baking6/class.jpg"
        >
          <template v-slot:loading>
            <van-loading size="20" color="#fff" />
          </template>
        </van-image>
      </div>
      <find></find>
      <indexTitle title1="学员作品" title2="有颜值，更有内涵"></indexTitle>
      <swipe3 :swipeUrls="workUrl"></swipe3>
    </div>
    <formMiddle></formMiddle>
    <div class="content">
      <indexTitle
        title1="名师风采"
        title2="精英名师亲授，助力你的成功事业路"
      ></indexTitle>
      <swipe3 :swipeUrls="teacherUrl"></swipe3>
      <find></find>
      <indexTitle
        title1="严选教学设备"
        title2="小班上课，确保上课质量"
      ></indexTitle>
      <div class="shebei">
        <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/baking9/shebei.jpg"
        >
          <template v-slot:loading>
            <van-loading size="20" color="#fff" />
          </template>
        </van-image>
      </div>
      <indexTitle
        title1="创业帮扶"
        title2="全国30余家院校联动，全方位创业扶持"
      ></indexTitle>
      <tab2></tab2>
      <indexTitle
        title1="成功创业学员"
        title2="迷茫的年纪，成功的选择"
      ></indexTitle>
      <swipe3 :swipeUrls="successUrl"></swipe3>
      <indexTitle
        title1="优秀就业学员"
        title2="为了同一个梦，欧米奇学子靠行动驱动人生！"
      ></indexTitle>
      <swipe3 :swipeUrls="jobUrl"></swipe3>
      <find></find>
      <div style="width:100%;height:20px;"></div>
      <indexTitle title1="学员评价" title2="我们所有的努力只为了得到你们的认可"></indexTitle>
      <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/dessert/talk.jpg">
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <indexTitle title1="推荐就业" title2="校企合作，定向委托"></indexTitle>
      <div class="logo">
        <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/baking6/logo.jpg"
        >
          <template v-slot:loading>
            <van-loading size="20" color="#fff" />
          </template>
        </van-image>
      </div>
      <indexTitle
        title1="选择课程 了解学费"
        title2="Choose a course to learn about tuition"
      ></indexTitle>
      <footerForm color="#fff" bag="#a96b04" words="点击获取学费报价"></footerForm>
    </div>
    <!-- <div class="h25px" style="width:100%;height:25px;"></div> -->
    <foot></foot>
  </div>
</template>
<script>
export default {
  data() {
    return {
      workUrl: [
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/baking6/work1.jpg",
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/baking6/work2.jpg"
      ],
      teacherUrl: [
        //名师风采
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/baking9/teacher1.jpg",
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/baking9/teacher2.jpg",
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/baking9/teacher3.jpg"
      ],
      successUrl: [
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/baking6/chuangye1.jpg",
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/baking6/chuangye2.jpg"
      ],
      jobUrl: [
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/baking6/job1.jpg",
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/baking6/job2.jpg"
      ]
    };
  },
  components: {
    back: () => import("../../../components/head/back"),
    landingBanner: () => import("../../../components/common/landing-banner"),
    indexTitle: () => import("@/components/common/indexTitle"),
    find: () => import("@/components/common/find"),
    swipe3: () => import("@/components/common/swipe3"),
    tab2: () => import("@/components/common/tab2"),
    formMiddle: () => import("@/components/form/formMiddle"),
    footerForm: () => import("@/components/form/footerForm"),
    foot: () => import("@/components/foot/foot")
  },
  mounted() {}
};
</script>
<style lang="less" scoped>
/deep/ .van-swipe__indicators{
  bottom: 15px;
    left: 10%;
}
.main {
  margin-top: 50px;
}
.content {
  padding: 10px;
}
</style>
